 import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {UserService} from '../../user.service';

@Injectable()
export class ClientGuard implements CanActivate {

  constructor(private service: UserService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.service.isClient() || this.service.isSecondUser()) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
